module.exports = __webpack_public_path__ + "assets/img/knowbanner2.e0fb1766.jpg";